import { useContext, useEffect, useRef } from "react";

import { CurrentLeagueContext } from "./CurrentLeagueContext";

export const useCurrentLeagueContext = () => {
  return useContext(CurrentLeagueContext);
};

export const useCurrentLeague = () => {
  const { league } = useCurrentLeagueContext();
  return league;
};

export const useSwitchLeague = () => {
  const { switchLeague } = useCurrentLeagueContext();
  return switchLeague;
};

export const useOnCurrentLeagueChange = (callback: () => void) => {
  const league = useCurrentLeague();
  const callbackRef = useRef(callback);
  callbackRef.current = callback;
  const isFirstRunRef = useRef(true);

  useEffect(() => {
    if (isFirstRunRef.current) {
      isFirstRunRef.current = false;
      return;
    }
    callbackRef.current();
  }, [league?.id]);
};
